import { IDocument } from "./IDocument";
import { IVisitatieRapportData } from "./IVisitatieRapport";

export interface IGoedePraktijkOperationeleDoelstelling {
    id: number;
    operationeleDoelstellingId: number;
}

export interface IGoedePraktijkThema {
    id: number;
    themaId: number;
}

interface IGoedePraktijkBase {
    id: number;
    titel: string;
    htmlOmschrijving: string;
    visitatieRapportId?: number;
    gepubliceerd: boolean;
}

export interface IGoedePraktijkDocument {
    id: number;
    documentId: number;
    document?: IDocument
}

export interface IGoedePraktijk extends IGoedePraktijkBase {
    [x: string]: any;
    operationeleDoelstellingen: number[];
    themas: number[];
    documenten: IDocument[];
}

export interface IGoedePraktijkData extends IGoedePraktijkBase {
    operationeleDoelstellingen: IGoedePraktijkOperationeleDoelstelling[];
    themas: IGoedePraktijkThema[];
    documenten: IGoedePraktijkDocument[];    

}
const defaultGoedePraktijk: IGoedePraktijk = {
    id: 0,
    documenten: [],
    htmlOmschrijving: "",
    operationeleDoelstellingen: [],
    themas: [],
    titel: "",
    gepubliceerd: false
    //visitatieRapportId: 0
}

export interface IGoedePraktijkPublicData {
    id: number;
    titel: string;
    visitatieRapportDocument: IDocument;
    themas: string[];
    //operationeleDoelstellingen: string[];
    documenten: IDocument[];
    htmlOmschrijving: string;    
}

export const DefaultGoedePraktijk = () => defaultGoedePraktijk;